import script from "./inputConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./inputConfirm.vue?vue&type=script&lang=ts&setup=true"

import "./inputConfirm.vue?vue&type=style&index=0&id=7e71f9ef&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e71f9ef"]])

export default __exports__